

export function coerceToBoolean(value: any) {

  const type = typeof value;

  if (type === 'boolean') {
    return value;
  } else if (type === 'string') {
    switch (value.toLowerCase()) {
      case 'true': return true;
      case 'false': return false;
      case 'yes': return true;
      case 'no': return false;
      case '': return false;
      default: return true;
    }

  }

  return !!value;

}


export function coerceToYesNo(value: any) {

  if (value === null || value === undefined) {
    return value;
  }

  const type = typeof value;

  if (type === 'boolean') {
    return value ? 'Yes': 'No';
  } else if (type === 'string') {
    return value.toLowerCase() === 'yes' ? 'yes' : 'no';
  }

  return 'no';

}